import { Box, Typography, TextField, Button, Grid, Divider, CircularProgress, useTheme, IconButton, InputAdornment } from '@mui/material'
import { useAuth } from '../../../shared/context/authContext';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import sigmalogo from '../../../assets/sigmalogo.png';

export default function FormLoginComponent() {

    const { loginWithMicrosoft, loginWithEmail, loadingLoginEmail, messageError, loadingRedirectCallback } = useAuth();
    const [showPassword, setShowPassword] = useState(false);
    const theme = useTheme()

    const { control, handleSubmit, formState: { errors, isValid }, watch } = useForm({
        defaultValues: {
            email: '',
            password: ''
        },
        mode: 'onChange'
    });

    const email = watch('email')
    const password = watch('password')

    const onSubmit = async (data) => {
        const success = await loginWithEmail(data.email, data.password);
        if (success) {
            navigate('/dashboard');
        }
    };

    return (
        <Box sx={{ maxWidth: { xs: '350px', md: '450px' }, margin: '0 auto', backgroundColor: theme.palette.background.medium, padding: '20px', borderRadius: '10px' }}>

            {/*  <Typography 
                        variant="h6" 
                        component="div" 
                        className='logoFont'
                        sx={{ 
                            color: theme.palette.text.primary,
                            fontWeight: 600,
                            letterSpacing: '0.5px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            justifyContent: 'center',
                            marginBottom: '20px',
                            fontSize: '1.9rem'
                        }}
                    >
                        <img src={checkIso} alt="checkIso" style={{ width: '40px', height: '40px' }} />
                        MantTrack
                    </Typography>*/}

            <Typography
                variant="h6"
                component="div"
                className='logoFont'
                sx={{
                    color: theme.palette.text.primary,
                    fontWeight: 600,
                    letterSpacing: '0.5px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    justifyContent: 'center',
                    marginBottom: '20px',
                    fontSize: '1.9rem'
                }}
            >
                <img src={sigmalogo} alt="sigmalogo" style={{ width: '70px', height: '70px' }} />
                SIGMA
            </Typography>
            {/*<Typography variant="h6" sx={{ fontSize: '1rem', textAlign: 'center' }}>Gestión de Mantenimiento, diseñado para CETEMIN</Typography>*/}
            <Typography variant="h6" sx={{ fontSize: '1rem', textAlign: 'center' }}>Sistema de Gestión y Mantenimiento</Typography>

            <Divider sx={{ my: 2 }} />
            <Box sx={{ mb: 3 }}>
                <Typography variant="body1" sx={{ mb: 2, textAlign: 'center', fontSize: '0.9rem' }}>
                    Inicia sesión con tu cuenta institucional
                </Typography>
                <Button
                    variant="outlined"
                    fullWidth
                    onClick={loginWithMicrosoft}
                    disabled={loadingRedirectCallback}
                    startIcon={
                        loadingRedirectCallback ? <CircularProgress size={20} /> : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 23 23">
                            <path fill="#f3f3f3" d="M0 0h23v23H0z" />
                            <path fill="#f35325" d="M1 1h10v10H1z" />
                            <path fill="#81bc06" d="M12 1h10v10H12z" />
                            <path fill="#05a6f0" d="M1 12h10v10H1z" />
                            <path fill="#ffba08" d="M12 12h10v10H12z" />
                        </svg>
                    }
                    sx={{
                        py: 1,
                        borderRadius: 1,
                        textTransform: 'none',
                        fontSize: '0.9rem'
                    }}
                >
                    Iniciar sesión con Microsoft
                </Button>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
                <Divider sx={{ flex: 1 }} />
                <Typography variant="body2" sx={{ px: 2, color: 'text.secondary' }}>
                    o
                </Typography>
                <Divider sx={{ flex: 1 }} />
            </Box>

            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12, md: 12 }}>
                        <Controller
                            control={control}
                            name="email"
                            rules={{
                                required: 'El correo electrónico es requerido',
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: 'El correo electrónico no es válido'
                                }
                            }}
                            render={({ field }) => (
                                <TextField
                                    label="Correo electrónico"
                                    name="email"
                                    type="email"
                                    required
                                    fullWidth
                                    value={email}
                                    onChange={field.onChange}
                                    error={!!errors.email}
                                    helperText={errors.email?.message}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 12 }}>
                        <Controller
                            control={control}
                            name="password"
                            rules={{
                                required: 'La contraseña es requerida',
                            }}
                            render={({ field }) => (
                                <TextField
                                    label="Contraseña"
                                    name="password"
                                    type={showPassword ? 'text' : 'password'}
                                    required
                                    fullWidth
                                    value={password}
                                    onChange={field.onChange}
                                    error={!!errors.password}
                                    helperText={errors.password?.message}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 12 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            size="large"
                            disabled={loadingLoginEmail}
                            sx={{ fontSize: '1rem', fontWeight: 'bold' }}
                        >
                            {loadingLoginEmail ? <CircularProgress size={24} /> : 'Ingresar a la plataforma'}
                        </Button>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 12 }}>
                        <Typography variant="body2" sx={{ textAlign: 'center', fontSize: '0.9rem', color: 'red' }}>
                            {messageError}
                        </Typography>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 12 }}>
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                textAlign: 'center', 
                                fontSize: '0.75rem', 
                                color: theme.palette.text.secondary,
                                mt: 1
                            }}
                        >
                            Desarrollado por Equipo TIC - 2025 - v2
                        </Typography>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}